import { render, staticRenderFns } from "./ProjectManagementDeleteColumnModal.vue?vue&type=template&id=0d241554&"
import script from "./ProjectManagementDeleteColumnModal.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementDeleteColumnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports